import { render, staticRenderFns } from "./diySlider.vue?vue&type=template&id=bc25e674&scoped=true&"
import script from "./diySlider.vue?vue&type=script&lang=js&"
export * from "./diySlider.vue?vue&type=script&lang=js&"
import style0 from "./diySlider.vue?vue&type=style&index=0&id=bc25e674&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc25e674",
  null
  
)

export default component.exports